module.exports = __webpack_public_path__ + "static/media/day-3.f391eb32.jpg";